import UriTemplate from 'uri-templates';
import HttpTrackerService from '../-http-tracker/http_tracker';

angular
    .module('angular-hal', []);

/*
TODO: To be moved into a separate file
 */

class DataCacheService {
    constructor() {
        this.data = [];
    }

    set(key, val) {
        this.data[key] = val;
        return val;
    }

    get(key) {
        return this.data[key];
    }

    del(key) {
        delete this.data[key];
    }

    has(key) {
        return (key in this.data);
    }

    delMatching(str) {
        for (const key in this.data) {
            if (key.indexOf(str) !== -1)
                delete this.data[key];
        }
    }
}

angular
    .module('angular-hal').service('data_cache', DataCacheService);


/*
TODO: To be moved into a separate file
 */

class SharedHeaderService {
    constructor() {
        this.data = [];
    }

    set(key, val, store) {
        // also store this in the session store
        store.setItem(key, val);
        this.data[key] = val;
        return val;
    }

    get(key) {
        return this.data[key];
    }

    del(key) {
        delete this.data[key];
    }

    has(key) {
        return (key in this.data);
    }
}

angular
    .module('angular-hal')
    .service('shared_header', SharedHeaderService);


angular
    .module('angular-hal')
    .factory('halClient',
        ($http, $q, data_cache, shared_header, $cookies, $sessionStorage, $localStorage) => {

            if ($sessionStorage.getItem('auth_token'))
                shared_header.set('auth_token', $sessionStorage.getItem('auth_token'), $sessionStorage);
            else if ($cookies.get('Auth-Token') && !shared_header.has('auth_token')) {
                shared_header.set('auth_token', $cookies.get('Auth-Token'), $sessionStorage);
            }

            /*
            Shared token among the resource requests
             */
            const sharedOptions = {};

            return {
                setCache: (cache) => {
                    data_cache = cache;
                },
                clearCache: (str) => {
                    data_cache.delMatching(str);
                },
                createResource: (store) => {
                    if (typeof store === 'string') {
                        store = JSON.parse(store);
                    }
                    const resource = store.data;
                    resource._links = store.links;
                    const key = store.links.self.href;
                    const options = store.options;
                    return new BaseResource(key, options, resource);
                },
                $get: (href, options) => {
                    if (
                        data_cache.has(href) &&
                        (!options || !options.no_cache)
                    ) {
                        return data_cache.get(href);
                    }
                    return data_cache.set(href, callService('GET', href, options));
                    //        return callService('GET', href, options);
                }//get
                , $post: (href, options, data) => {
                    return callService('POST', href, Object.assign({}, options, sharedOptions), data);
                }//post
                , $put: (href, options, data) => {
                    return callService('PUT', href, Object.assign({}, options, sharedOptions), data);
                }//put
                , $patch: (href, options, data) => {
                    return callService('PATCH', href, Object.assign({}, options, sharedOptions), data);
                }//patch
                , $del: (href, options, data) => {
                    return callService('DELETE', href, Object.assign({}, options, sharedOptions), data);
                }//del
                , $parse: (data) => {
                    return parseHal(data);
                }//parse
            };


            function BaseResource(href, options, data, extra) {

                if (!options) options = {};
                if (!extra) extra = {};

                const links = {};
                const embedded = data_cache;
                if (data.hasOwnProperty('auth_token')) {
                    options['auth_token'] = data['auth_token'];
                }

                if (options.auth_token) {
                    sharedOptions.auth_token = options.auth_token;
                }

                href = getSelfLink(href, data).href;

                this.$href = (rel, params) => {
                    if (!(rel in links)) return null;

                    return hrefLink(links[rel], params);
                };
                this.$has = (rel) => {
                    return rel in links;
                };
                this.$flush = (rel, params) => {
                    const link = links[rel];
                    return flushLink(link, params);
                };
                this.$get = (rel, params) => {
                    const link = links[rel];
                    return callLink('GET', link, params);
                };
                this.$post = (rel, params, data) => {
                    const link = links[rel];
                    return callLink('POST', link, params, data);
                };
                this.$put = (rel, params, data) => {
                    const link = links[rel];
                    return callLink('PUT', link, params, data);
                };
                this.$patch = (rel, params, data) => {
                    const link = links[rel];
                    return callLink('PATCH', link, params, data);
                };
                this.$del = (rel, params, data) => {
                    const link = links[rel];
                    return callLink('DELETE', link, params, data);
                };
                this.$links = () => {
                    return links;
                };
                this.$toStore = () => {
                    return JSON.stringify({
                        data: this,
                        links,
                        options: Object.assign({}, options, sharedOptions)
                    });
                };
                this.setOption = (key, value) => {
                    options[key] = value;
                };
                this.getOption = (key) => {
                    return options[key];
                };
                this.$link = (rel) => {
                    return links[rel];
                };

                Object.keys(data)
                    .filter((key) => {
                        return !~['_', '$'].indexOf(key[0]);
                    })
                    .forEach(function (key) {
                        this[key] = data[key];
                        //        Object.defineProperty(this, key, {
                        //        configurable: false
                        //        , enumerable: true
                        //        , value: data[key]
                        //     });
                    }, this)
                    ;


                if (data._links) {
                    Object
                        .keys(data._links)
                        .forEach((rel) => {
                            let link = data._links[rel];
                            link = normalizeLink(href, link);
                            links[rel] = link;
                        }, this)
                        ;
                }

                if (data._embedded) {
                    Object
                        .keys(data._embedded)
                        .forEach((rel) => {
                            const embedded = data._embedded[rel];
                            const link = getSelfLink(href, embedded);
                            links[rel] = link;

                            const resource = createResource(href, Object.assign({}, options, sharedOptions), embedded);

                            embedResource(resource);

                        }, this);
                }

                if (extra.is_new) this.is_new = true;

                // function defineHiddenProperty(target, name, value) {
                //     target[name] = value;
                //     // Object.defineProperty(target, name, {
                //     // configurable: false
                //     //     , enumerable: false
                //     //    , value: value
                //     // });
                // }//defineHiddenProperty


                function embedResource(resource) {
                    if (angular.isArray(resource)) return resource.map((resource) => {
                        return embedResource(resource);
                    });

                    const href = resource.$href('self');

                    embedded.set(href, $q.when(resource));
                }//embedResource

                function hrefLink(link, params) {
                    // don't mess with the original params, so create a local copy
                    const localParams = Object.assign({}, params);

                    params && Object.keys(params).forEach((paramKey) => {
                        if (params[paramKey] && params[paramKey].constructor === Object && params[paramKey] instanceof Object) {
                            const replacingString = [];

                            // Search for nested params (hashes)
                            Object.keys(params[paramKey]).forEach((hashKey) => {
                                replacingString.push(`${paramKey}[${hashKey}]`);
                                localParams[`${paramKey}[${hashKey}]`] = params[paramKey][hashKey];
                            });

                            if (Object.keys(params[paramKey]).length > 0) {
                                // replace the key with a string built to support nested params
                                // i.e filter_by[date] which was serialised as filter_by=date,<value>
                                const regex = new RegExp(`${paramKey}(?!\\[)`);
                                link.href = link.href.replace(regex, replacingString.join());
                            }
                        }
                    });

                    const href = link.templated
                        ? new UriTemplate(link.href).fillFromObject(localParams || {})
                        : link.href
                        ;

                    return href;
                }//hrefLink

                function callLink(method, link, params, data) {
                    if (params == null) {
                        params = {};
                    }

                    if (angular.isArray(link)) return $q.all(link.map((link) => {
                        if (method !== 'GET') throw 'method is not supported for arrays';

                        return callLink(method, link, params, data);
                    }));

                    const linkHref = hrefLink(link, params);
                    if (method === 'GET') {
                        if (embedded.has(linkHref) && !params['no_cache']) {
                            return embedded.get(linkHref);
                        } else {
                            return embedded.set(linkHref, callService(method, linkHref, Object.assign({}, options, sharedOptions), data));
                        }
                    } else {
                        return callService(method, linkHref, Object.assign({}, options, sharedOptions), data);
                    }

                }//callLink

                function flushLink(link, params) {
                    if (angular.isArray(link)) return link.map((link) => {
                        return flushLink(link, params);
                    });

                    const linkHref = hrefLink(link, params);
                    if (embedded.has(linkHref)) embedded.del(linkHref);
                }//flushLink

            }//Resource


            function createResource(href, options, data, extra) {
                if (angular.isArray(data)) return data.map((data) => {
                    return createResource(href, options, data, extra);
                });

                const resource = new BaseResource(href, options, data, extra);

                return resource;

            }//createResource


            function normalizeLink(baseHref, link) {
                if (angular.isArray(link)) return link.map((link) => {
                    return normalizeLink(baseHref, link);
                });

                if (link) {
                    if (typeof link === 'string') link = { href: link };
                    link.href = resolveUrl(baseHref, link.href);
                } else {
                    link = { href: baseHref };
                }

                return link;
            }//normalizeLink


            function getSelfLink(baseHref, resource) {
                if (angular.isArray(resource)) return resource.map((resource) => {
                    return getSelfLink(baseHref, resource);
                });

                return normalizeLink(baseHref, resource && resource._links && resource._links.self);
            }//getSelfLink


            function callService(method, href, options = {}, data) {
                if (!options) options = {};
                const headers = {
                    'Content-Type': 'application/json',
                    Accept: 'application/hal+json,application/json'
                };
                if (options.authorization) headers.Authorization = options.authorization;
                if (options.app_id) shared_header.set('app_id', options.app_id, $sessionStorage);
                if (options.app_key) shared_header.set('app_key', options.app_key, $sessionStorage);
                if (options.auth_token) {
                    $sessionStorage.setItem('auth_token', options.auth_token);
                    shared_header.set('auth_token', options.auth_token, $sessionStorage);
                }

                if (shared_header.has('app_id')) headers['App-Id'] = shared_header.get('app_id');
                if (shared_header.has('app_key')) headers['App-Key'] = shared_header.get('app_key');

                if (shared_header.has('auth_token')) headers['Auth-Token'] = shared_header.get('auth_token');

                if (options.bypass_auth) headers['Bypass-Auth'] = options.bypass_auth;

                // BOOKINGLAB CHANGE \\
                // replace v1 with v5
                // if href does not include the word "coupon" then make it a v5 call
                // we do this because coupons api calls are differant on v5 and fails to work
                if (href.indexOf('coupon') === -1) {
                    href = href.replace('v1', 'v5');
                } else {
                    href = href.replace('v5', 'v1');
                }

                const resource = (
                    $http({
                        method
                        , url: options.transformUrl ? options.transformUrl(href) : href
                        , headers
                        , data
                    })
                        .then((res) => {

                            HttpTrackerService.success({
                                method,
                                url: options.transformUrl ? options.transformUrl(href) : href,
                                headers,
                                data,
                                result: res
                            });

                            // copy out the auth token from the header if the response is new resource
                            // Note: we only take the auth token from created responses as at the app layer, success responses might be cached results, thus we don't want to use the auth token from these
                            if (res.headers('auth-token') && res.status == 201) {
                                options.auth_token = res.headers('Auth-Token');
                                shared_header.set('auth_token', res.headers('Auth-Token'), $sessionStorage);
                                // if auth token is present in local storage, set it there too
                                if ($localStorage.getItem('auth_token'))
                                    $localStorage.setItem('auth_token', res.headers('Auth-Token'));
                            }
                            switch (res.status) {
                                case 200:
                                    //For back-ends that return `"null"` instead of `null` -_-
                                    if (res.data && res.data !== '"null"') return createResource(href, options, res.data);
                                    return null;

                                case 201:
                                    if (res.data) return createResource(href, options, res.data, { is_new: true });
                                    if (res.headers('Content-Location')) return res.headers('Content-Location');
                                    return null;

                                case 204:
                                    return null;

                                default:
                                    return $q.reject(res);
                            }
                        }, (res) => {
                            HttpTrackerService.error({
                                method,
                                url: options.transformUrl ? options.transformUrl(href) : href,
                                headers,
                                data,
                                result: res
                            });
                            return $q.reject(res);
                        })
                );

                return resource;
            }//callService

            function parseHal(data) {
                const resource = createResource(data._links.self.href, null, data);
                return resource;
            }//parseHal


            function resolveUrl(baseHref, href) {
                let resultHref = '';
                const reFullUrl = /^((?:\w+\:)?)((?:\/\/)?)([^\/]*)((?:\/.*)?)$/;
                const baseHrefMatch = reFullUrl.exec(baseHref);
                const hrefMatch = reFullUrl.exec(href);

                for (let partIndex = 1; partIndex < 5; partIndex++) {
                    if (hrefMatch[partIndex]) resultHref += hrefMatch[partIndex];
                    else resultHref += baseHrefMatch[partIndex];
                }

                return resultHref;
            }//resolveUrl

        }
    )//service
    ;



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_components/angular_hal.js